import { error } from "jquery";

export const fetchFromAPI = async <T>(
  endpoint: string,
  method = 'GET',
  body?: any,
  headers: Record<string, string> = {},
): Promise<T> => {
  const options: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(endpoint, options);
  let responseData;
  
  try {
    responseData = await response.json();
  } catch (parseError) {
    console.error('Failed to parse response:', parseError);
    throw { status: response.status, message: `Unexpected server response (${response.status})` };
  }

  if (!response.ok) {

    throw responseData;
  }

  return responseData;
};
